// extracted by mini-css-extract-plugin
module.exports = {"root":"_2P1H-","spinner":"_2675l","rotate":"_2njbm","path":"yRp-K","dash":"J40uP"};